import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const SEARCH_VALIDATION_RESULTS_REQUEST = 'SEARCH_VALIDATION_RESULTS_REQUEST';
export const SEARCH_VALIDATION_RESULTS_SUCCESS = 'SEARCH_VALIDATION_RESULTS_SUCCESS';
export const SEARCH_VALIDATION_RESULTS_FAILURE = 'SEARCH_VALIDATION_RESULTS_FAILURE';

function requestSearchValidationResults() {
  return {
    type: SEARCH_VALIDATION_RESULTS_REQUEST,
    isGettingReporting: true
  };
}

function receiveSearchValidationResults(reportingResponse) {
  return {

    type: SEARCH_VALIDATION_RESULTS_SUCCESS,
    isGettingReporting: false,
    reportingResponse,
    reportingError: null
  };
}

function rejectSearchValidationResults(reportingError) {
  return {
    type: SEARCH_VALIDATION_RESULTS_FAILURE,
    isGettingReporting: false,
    reportingError
  };
}

export function searchValidationResults(
  pageNumber,
  pageSize,
  totalLimit,
  sortBy,
  sortDirection,
  filters,
  searchQuery,
  dateFrom,
  dateTo,
  activeTab
) {
  return (dispatch) => {
    dispatch(requestSearchValidationResults());

    const promise = () => ApiService
      .searchValidationResults(pageNumber, pageSize, totalLimit, sortBy, sortDirection, filters, searchQuery, dateFrom, dateTo, activeTab)
      .then((response) => {
        dispatch(receiveSearchValidationResults(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSearchValidationResults, true));
        }
      });
    return promise();
  };
}
